/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './productedit.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/material';
import * as i3 from '@angular/cdk';
import * as i4 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '@angular/flex-layout/media-query/media-monitor';
import * as i7 from '@angular/forms';
import * as i8 from '@angular/router';
import * as i9 from '@angular/common';
import * as i10 from '../../../../app/containers/productedit/productedit.component';
import * as i11 from '../../../../app/shared/auth.service';
import * as i12 from '../../../../app/shared/constants/baseurl.constants';
import * as i13 from '../../../../app/shared/software.service';
const styles_ProductEditComponent:any[] = [i0.styles];
export const RenderType_ProductEditComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ProductEditComponent,data:{}});
function View_ProductEditComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(16777216,(null as any),(null as any),22,'div',
      [['mdTooltip',''],['mdTooltipPosition','after']],(null as any),[[(null as any),
          'longpress'],[(null as any),'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,2).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,5)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),i1.ɵqud(603979776,
          3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),i1.ɵqud(603979776,
          5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,6,'input',[['class','mat-input-element'],['disabled',''],
              ['id','Id'],['mdInput',''],['name','Id'],['placeholder','Product Id'],
              ['value','Id']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,15)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,15).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,15)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,15)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,20)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,20)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,20)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.Id = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,[[1,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,
          [2,i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled'],id:[1,'id'],placeholder:[2,'placeholder']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'after';
    const currVal_1:any = '';
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_12:any = 'product-full-width';
    _ck(_v,12,0,currVal_12);
    const currVal_26:any = 'Id';
    const currVal_27:any = '';
    const currVal_28:any = _co.product.Id;
    _ck(_v,17,0,currVal_26,currVal_27,currVal_28);
    const currVal_29:any = '';
    const currVal_30:any = 'Id';
    const currVal_31:any = 'Product Id';
    _ck(_v,20,0,currVal_29,currVal_30,currVal_31);
  },(_ck,_v) => {
    const currVal_2:any = (null as any);
    const currVal_3:any = i1.ɵnov(_v,5)._mdInputChild._isErrorState();
    const currVal_4:any = i1.ɵnov(_v,5)._mdInputChild.focused;
    const currVal_5:any = i1.ɵnov(_v,5)._shouldForward('untouched');
    const currVal_6:any = i1.ɵnov(_v,5)._shouldForward('touched');
    const currVal_7:any = i1.ɵnov(_v,5)._shouldForward('pristine');
    const currVal_8:any = i1.ɵnov(_v,5)._shouldForward('dirty');
    const currVal_9:any = i1.ɵnov(_v,5)._shouldForward('valid');
    const currVal_10:any = i1.ɵnov(_v,5)._shouldForward('invalid');
    const currVal_11:any = i1.ɵnov(_v,5)._shouldForward('pending');
    _ck(_v,4,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,
        currVal_9,currVal_10,currVal_11);
    const currVal_13:any = i1.ɵnov(_v,19).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,19).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,19).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,19).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,19).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,19).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,19).ngClassPending;
    const currVal_20:any = i1.ɵnov(_v,20).id;
    const currVal_21:any = i1.ɵnov(_v,20).placeholder;
    const currVal_22:any = i1.ɵnov(_v,20).disabled;
    const currVal_23:any = i1.ɵnov(_v,20).required;
    const currVal_24:any = (i1.ɵnov(_v,20).ariaDescribedby || (null as any));
    const currVal_25:any = i1.ɵnov(_v,20)._isErrorState();
    _ck(_v,14,1,[currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,
        currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25]);
  });
}
function View_ProductEditComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['class',
      'mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],
      [2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],[8,'id',
          0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
          (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,
      en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i4.View_MdOption_0,i4.RenderType_MdOption)),i1.ɵdid(49152,[[37,4]],0,i2.MdOption,
      [i1.ElementRef,[2,i2.MdOptgroup],[2,i2.MATERIAL_COMPATIBILITY_MODE]],{value:[0,
          'value']},(null as any)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_8:any = _v.context.$implicit[1];
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit[0];
    _ck(_v,3,0,currVal_9);
  });
}
function View_ProductEditComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['class',
      'busy-overlay']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-progress-spinner',[['class',
          'product-spinner mat-progress-spinner'],['color','white'],['mode','indeterminate'],
          ['role','progressbar']],[[1,'aria-valuemin',0],[1,'aria-valuemax',0],[1,
          'aria-valuenow',0],[1,'mode',0]],(null as any),(null as any),i4.View_MdProgressSpinner_0,
          i4.RenderType_MdProgressSpinner)),i1.ɵdid(180224,(null as any),0,i2.MdProgressSpinner,
          [i1.Renderer2,i1.ElementRef,i1.NgZone],{color:[0,'color'],mode:[1,'mode']},
          (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdProgressSpinnerCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    const currVal_0:any = 'busy-overlay';
    _ck(_v,1,0,currVal_0);
    const currVal_5:any = 'white';
    const currVal_6:any = 'indeterminate';
    _ck(_v,4,0,currVal_5,currVal_6);
    const currVal_7:any = 'product-spinner';
    _ck(_v,6,0,currVal_7);
  },(_ck,_v) => {
    const currVal_1:any = i1.ɵnov(_v,4)._ariaValueMin;
    const currVal_2:any = i1.ɵnov(_v,4)._ariaValueMax;
    const currVal_3:any = i1.ɵnov(_v,4).value;
    const currVal_4:any = i1.ɵnov(_v,4).mode;
    _ck(_v,3,0,currVal_1,currVal_2,currVal_3,currVal_4);
  });
}
export function View_ProductEditComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'h2',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),5,'a',([] as any[]),[[1,'target',0],[8,
          'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i8.RouterLinkWithHref,
      [i8.Router,i8.ActivatedRoute,i9.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),i1.ɵpad(1),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'md-icon',
      [['class','mat-icon'],['role','img'],['svgIcon','arrow-left']],(null as any),
      (null as any),(null as any),i4.View_MdIcon_0,i4.RenderType_MdIcon)),i1.ɵdid(16384,
      (null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(638976,(null as any),0,i2.MdIcon,[i1.Renderer2,
      i1.ElementRef,i2.MdIconRegistry,[8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),
      (_l()(),i1.ɵted((null as any),['Edit a Product'])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),181,'form',[['class',
          'product-form'],['novalidate',''],['style','max-width: 500px;']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'submit'],
          [(null as any),'reset']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,11).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.ɵbf,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i7.NgForm,[[8,
          (null as any)],[8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,
          (null as any),i7.ControlContainer,(null as any),[i7.NgForm]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatusGroup,[i7.ControlContainer],(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Product Properties'])),(_l()(),i1.ɵted((null as any),
          ['\n\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ProductEditComponent_1)),i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),24,'div',
          [['mdTooltip',''],['mdTooltipPosition','after']],(null as any),[[(null as any),
              'longpress'],[(null as any),'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,24).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,24).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,27)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),i1.ɵqud(603979776,
          9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),i1.ɵqud(603979776,
          11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,8,'input',[['class','mat-input-element'],['id','Name'],['mdInput',
              ''],['name','Name'],['placeholder','Product Name'],['required',''],['value',
              'Name']],[[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,37)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,37).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,37)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,37)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,44)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,44)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,44)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.Name = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i7.RequiredValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[7,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),25,'div',[['mdTooltip',''],['mdTooltipPosition','after']],
          (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,50).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,50).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,53)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          13,{_mdInputChild:0}),i1.ɵqud(335544320,14,{_placeholderChild:0}),i1.ɵqud(603979776,
          15,{_errorChildren:1}),i1.ɵqud(603979776,16,{_hintChildren:1}),i1.ɵqud(603979776,
          17,{_prefixChildren:1}),i1.ɵqud(603979776,18,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,9,'input',[['class','mat-input-element'],['id','UpdateId'],
              ['mdInput',''],['name','UpdateId'],['pattern','[a-z0-9-]+'],['placeholder',
                  'Update Id'],['required',''],['value','UpdateId']],[[1,'required',
              0],[1,'pattern',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,63)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,63).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,63)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,63)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,71)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,71)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,71)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.UpdateId = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵdid(540672,(null as any),0,
          i7.PatternValidator,([] as any[]),{pattern:[0,'pattern']},(null as any)),
      i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
        return [p0_0,p1_0];
      },[i7.RequiredValidator,i7.PatternValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[13,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),23,'div',[['mdTooltip',''],['mdTooltipPosition','after']],
          (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,77).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,77).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,80)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          19,{_mdInputChild:0}),i1.ɵqud(335544320,20,{_placeholderChild:0}),i1.ɵqud(603979776,
          21,{_errorChildren:1}),i1.ɵqud(603979776,22,{_hintChildren:1}),i1.ɵqud(603979776,
          23,{_prefixChildren:1}),i1.ɵqud(603979776,24,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'textarea',[['class','mat-input-element'],['id','Description'],
              ['mdInput',''],['name','Description'],['placeholder','Product Description'],
              ['value','Description']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,90)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,90).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,90)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,90)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,95)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,95)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,95)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.Description = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[19,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,i3.Platform,[2,i7.NgControl],[2,i7.NgForm],[2,
              i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],{id:[0,'id'],
              placeholder:[1,'placeholder']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['            '])),(_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),24,'div',[['mdTooltip',''],['mdTooltipPosition',
              'after']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,102).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,102).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,105)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          25,{_mdInputChild:0}),i1.ɵqud(335544320,26,{_placeholderChild:0}),i1.ɵqud(603979776,
          27,{_errorChildren:1}),i1.ɵqud(603979776,28,{_hintChildren:1}),i1.ɵqud(603979776,
          29,{_prefixChildren:1}),i1.ɵqud(603979776,30,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,8,'input',[['class','mat-input-element'],['id','IconUrl'],
              ['mdInput',''],['name','IconUrl'],['placeholder','Icon'],['required',
                  ''],['value','IconUrl']],[[1,'required',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',
                  0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,115)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,115).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,115)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,115)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,122)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,122)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,122)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.IconUrl = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i7.RequiredValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[25,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),24,'div',[['mdTooltip',''],['mdTooltipPosition','after']],
          (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,128).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,128).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',
          [['class','product-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,131)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          31,{_mdInputChild:0}),i1.ɵqud(335544320,32,{_placeholderChild:0}),i1.ɵqud(603979776,
          33,{_errorChildren:1}),i1.ɵqud(603979776,34,{_hintChildren:1}),i1.ɵqud(603979776,
          35,{_prefixChildren:1}),i1.ɵqud(603979776,36,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,8,'input',[['class','mat-input-element'],['id','ImageUrl'],
              ['mdInput',''],['name','ImageUrl'],['placeholder','Image'],['required',
                  ''],['value','ImageUrl']],[[1,'required',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',
                  0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,141)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,141).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,141)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,141)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,148)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,148)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,148)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.product.ImageUrl = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i7.RequiredValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[31,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),17,'div',[['mdTooltip','Product release status'],['mdTooltipPosition',
              'after']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,154).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,154).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'md-select',
          [['class','product-full-width mat-select'],['name','Status'],['placeholder',
              'Release Status'],['role','listbox']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,
                  'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',0],
              [1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown'],[(null as any),
              'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,161)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,161)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.product.Status = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i4.View_MdSelect_0,i4.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i7.NgModel,[[2,i7.ControlContainer],[8,(null as any)],[8,(null as any)],
              [8,(null as any)]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          2,i2.MdSelect,[i2.ViewportRuler,i1.ChangeDetectorRef,i1.Renderer2,i1.ElementRef,
              [2,i3.Directionality],[2,i7.NgControl],[8,(null as any)],[2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵqud(603979776,37,{options:1}),
      i1.ɵqud(603979776,38,{optionGroups:1}),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_ProductEditComponent_2)),i1.ɵdid(802816,(null as any),0,i9.NgForOf,
          [i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),15,'div',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',
          [['class','product-button mat-raised-button'],['color','primary'],['md-raised-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.saveProduct(_co.product)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i2.MdButton,
          [i1.Renderer2,i1.ElementRef,i3.Platform,i2.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i2.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Save'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',
          [['class','product-button mat-raised-button'],['md-raised-button','']],[[8,
              'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.ProductEditComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i2.MdButton,
          [i1.Renderer2,i1.ElementRef,i3.Platform,i2.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Cancel'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ProductEditComponent_3)),
      i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    \n'])),(_l()(),
          i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i10.ProductEditComponent = _v.component;
    const currVal_2:any = _ck(_v,3,0,'/products');
    _ck(_v,2,0,currVal_2);
    const currVal_3:any = 'arrow-left';
    _ck(_v,6,0,currVal_3);
    const currVal_11:any = 'product-form';
    _ck(_v,14,0,currVal_11);
    const currVal_12:any = (_co.product.Id > 0);
    _ck(_v,20,0,currVal_12);
    const currVal_13:any = 'after';
    const currVal_14:any = '';
    _ck(_v,24,0,currVal_13,currVal_14);
    const currVal_25:any = 'product-full-width';
    _ck(_v,34,0,currVal_25);
    const currVal_40:any = '';
    _ck(_v,38,0,currVal_40);
    const currVal_41:any = 'Name';
    const currVal_42:any = _co.product.Name;
    _ck(_v,41,0,currVal_41,currVal_42);
    const currVal_43:any = 'Name';
    const currVal_44:any = 'Product Name';
    const currVal_45:any = '';
    _ck(_v,44,0,currVal_43,currVal_44,currVal_45);
    const currVal_46:any = 'after';
    const currVal_47:any = '';
    _ck(_v,50,0,currVal_46,currVal_47);
    const currVal_58:any = 'product-full-width';
    _ck(_v,60,0,currVal_58);
    const currVal_74:any = '';
    _ck(_v,64,0,currVal_74);
    const currVal_75:any = '[a-z0-9-]+';
    _ck(_v,65,0,currVal_75);
    const currVal_76:any = 'UpdateId';
    const currVal_77:any = _co.product.UpdateId;
    _ck(_v,68,0,currVal_76,currVal_77);
    const currVal_78:any = 'UpdateId';
    const currVal_79:any = 'Update Id';
    const currVal_80:any = '';
    _ck(_v,71,0,currVal_78,currVal_79,currVal_80);
    const currVal_81:any = 'after';
    const currVal_82:any = '';
    _ck(_v,77,0,currVal_81,currVal_82);
    const currVal_93:any = 'product-full-width';
    _ck(_v,87,0,currVal_93);
    const currVal_107:any = 'Description';
    const currVal_108:any = _co.product.Description;
    _ck(_v,92,0,currVal_107,currVal_108);
    const currVal_109:any = 'Description';
    const currVal_110:any = 'Product Description';
    _ck(_v,95,0,currVal_109,currVal_110);
    const currVal_111:any = 'after';
    const currVal_112:any = '';
    _ck(_v,102,0,currVal_111,currVal_112);
    const currVal_123:any = 'product-full-width';
    _ck(_v,112,0,currVal_123);
    const currVal_138:any = '';
    _ck(_v,116,0,currVal_138);
    const currVal_139:any = 'IconUrl';
    const currVal_140:any = _co.product.IconUrl;
    _ck(_v,119,0,currVal_139,currVal_140);
    const currVal_141:any = 'IconUrl';
    const currVal_142:any = 'Icon';
    const currVal_143:any = '';
    _ck(_v,122,0,currVal_141,currVal_142,currVal_143);
    const currVal_144:any = 'after';
    const currVal_145:any = '';
    _ck(_v,128,0,currVal_144,currVal_145);
    const currVal_156:any = 'product-full-width';
    _ck(_v,138,0,currVal_156);
    const currVal_171:any = '';
    _ck(_v,142,0,currVal_171);
    const currVal_172:any = 'ImageUrl';
    const currVal_173:any = _co.product.ImageUrl;
    _ck(_v,145,0,currVal_172,currVal_173);
    const currVal_174:any = 'ImageUrl';
    const currVal_175:any = 'Image';
    const currVal_176:any = '';
    _ck(_v,148,0,currVal_174,currVal_175,currVal_176);
    const currVal_177:any = 'after';
    const currVal_178:any = 'Product release status';
    _ck(_v,154,0,currVal_177,currVal_178);
    const currVal_194:any = 'Status';
    const currVal_195:any = _co.product.Status;
    _ck(_v,157,0,currVal_194,currVal_195);
    const currVal_196:any = 'Release Status';
    _ck(_v,161,0,currVal_196);
    const currVal_197:any = 'product-full-width';
    _ck(_v,164,0,currVal_197);
    const currVal_198:any = _co.releaseStatus;
    _ck(_v,167,0,currVal_198);
    const currVal_200:any = 'primary';
    _ck(_v,175,0,currVal_200);
    const currVal_201:any = 'product-button';
    _ck(_v,177,0,currVal_201);
    const currVal_203:any = 'product-button';
    _ck(_v,184,0,currVal_203);
    const currVal_204:any = _co.busy;
    _ck(_v,189,0,currVal_204);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_4:any = i1.ɵnov(_v,13).ngClassUntouched;
    const currVal_5:any = i1.ɵnov(_v,13).ngClassTouched;
    const currVal_6:any = i1.ɵnov(_v,13).ngClassPristine;
    const currVal_7:any = i1.ɵnov(_v,13).ngClassDirty;
    const currVal_8:any = i1.ɵnov(_v,13).ngClassValid;
    const currVal_9:any = i1.ɵnov(_v,13).ngClassInvalid;
    const currVal_10:any = i1.ɵnov(_v,13).ngClassPending;
    _ck(_v,9,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
    const currVal_15:any = (null as any);
    const currVal_16:any = i1.ɵnov(_v,27)._mdInputChild._isErrorState();
    const currVal_17:any = i1.ɵnov(_v,27)._mdInputChild.focused;
    const currVal_18:any = i1.ɵnov(_v,27)._shouldForward('untouched');
    const currVal_19:any = i1.ɵnov(_v,27)._shouldForward('touched');
    const currVal_20:any = i1.ɵnov(_v,27)._shouldForward('pristine');
    const currVal_21:any = i1.ɵnov(_v,27)._shouldForward('dirty');
    const currVal_22:any = i1.ɵnov(_v,27)._shouldForward('valid');
    const currVal_23:any = i1.ɵnov(_v,27)._shouldForward('invalid');
    const currVal_24:any = i1.ɵnov(_v,27)._shouldForward('pending');
    _ck(_v,26,0,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,
        currVal_21,currVal_22,currVal_23,currVal_24);
    const currVal_26:any = (i1.ɵnov(_v,38).required? '': (null as any));
    const currVal_27:any = i1.ɵnov(_v,43).ngClassUntouched;
    const currVal_28:any = i1.ɵnov(_v,43).ngClassTouched;
    const currVal_29:any = i1.ɵnov(_v,43).ngClassPristine;
    const currVal_30:any = i1.ɵnov(_v,43).ngClassDirty;
    const currVal_31:any = i1.ɵnov(_v,43).ngClassValid;
    const currVal_32:any = i1.ɵnov(_v,43).ngClassInvalid;
    const currVal_33:any = i1.ɵnov(_v,43).ngClassPending;
    const currVal_34:any = i1.ɵnov(_v,44).id;
    const currVal_35:any = i1.ɵnov(_v,44).placeholder;
    const currVal_36:any = i1.ɵnov(_v,44).disabled;
    const currVal_37:any = i1.ɵnov(_v,44).required;
    const currVal_38:any = (i1.ɵnov(_v,44).ariaDescribedby || (null as any));
    const currVal_39:any = i1.ɵnov(_v,44)._isErrorState();
    _ck(_v,36,1,[currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,
        currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,
        currVal_39]);
    const currVal_48:any = (null as any);
    const currVal_49:any = i1.ɵnov(_v,53)._mdInputChild._isErrorState();
    const currVal_50:any = i1.ɵnov(_v,53)._mdInputChild.focused;
    const currVal_51:any = i1.ɵnov(_v,53)._shouldForward('untouched');
    const currVal_52:any = i1.ɵnov(_v,53)._shouldForward('touched');
    const currVal_53:any = i1.ɵnov(_v,53)._shouldForward('pristine');
    const currVal_54:any = i1.ɵnov(_v,53)._shouldForward('dirty');
    const currVal_55:any = i1.ɵnov(_v,53)._shouldForward('valid');
    const currVal_56:any = i1.ɵnov(_v,53)._shouldForward('invalid');
    const currVal_57:any = i1.ɵnov(_v,53)._shouldForward('pending');
    _ck(_v,52,0,currVal_48,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,
        currVal_54,currVal_55,currVal_56,currVal_57);
    const currVal_59:any = (i1.ɵnov(_v,64).required? '': (null as any));
    const currVal_60:any = (i1.ɵnov(_v,65).pattern? i1.ɵnov(_v,65).pattern: (null as any));
    const currVal_61:any = i1.ɵnov(_v,70).ngClassUntouched;
    const currVal_62:any = i1.ɵnov(_v,70).ngClassTouched;
    const currVal_63:any = i1.ɵnov(_v,70).ngClassPristine;
    const currVal_64:any = i1.ɵnov(_v,70).ngClassDirty;
    const currVal_65:any = i1.ɵnov(_v,70).ngClassValid;
    const currVal_66:any = i1.ɵnov(_v,70).ngClassInvalid;
    const currVal_67:any = i1.ɵnov(_v,70).ngClassPending;
    const currVal_68:any = i1.ɵnov(_v,71).id;
    const currVal_69:any = i1.ɵnov(_v,71).placeholder;
    const currVal_70:any = i1.ɵnov(_v,71).disabled;
    const currVal_71:any = i1.ɵnov(_v,71).required;
    const currVal_72:any = (i1.ɵnov(_v,71).ariaDescribedby || (null as any));
    const currVal_73:any = i1.ɵnov(_v,71)._isErrorState();
    _ck(_v,62,1,[currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,
        currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,currVal_70,currVal_71,
        currVal_72,currVal_73]);
    const currVal_83:any = (null as any);
    const currVal_84:any = i1.ɵnov(_v,80)._mdInputChild._isErrorState();
    const currVal_85:any = i1.ɵnov(_v,80)._mdInputChild.focused;
    const currVal_86:any = i1.ɵnov(_v,80)._shouldForward('untouched');
    const currVal_87:any = i1.ɵnov(_v,80)._shouldForward('touched');
    const currVal_88:any = i1.ɵnov(_v,80)._shouldForward('pristine');
    const currVal_89:any = i1.ɵnov(_v,80)._shouldForward('dirty');
    const currVal_90:any = i1.ɵnov(_v,80)._shouldForward('valid');
    const currVal_91:any = i1.ɵnov(_v,80)._shouldForward('invalid');
    const currVal_92:any = i1.ɵnov(_v,80)._shouldForward('pending');
    _ck(_v,79,0,currVal_83,currVal_84,currVal_85,currVal_86,currVal_87,currVal_88,
        currVal_89,currVal_90,currVal_91,currVal_92);
    const currVal_94:any = i1.ɵnov(_v,94).ngClassUntouched;
    const currVal_95:any = i1.ɵnov(_v,94).ngClassTouched;
    const currVal_96:any = i1.ɵnov(_v,94).ngClassPristine;
    const currVal_97:any = i1.ɵnov(_v,94).ngClassDirty;
    const currVal_98:any = i1.ɵnov(_v,94).ngClassValid;
    const currVal_99:any = i1.ɵnov(_v,94).ngClassInvalid;
    const currVal_100:any = i1.ɵnov(_v,94).ngClassPending;
    const currVal_101:any = i1.ɵnov(_v,95).id;
    const currVal_102:any = i1.ɵnov(_v,95).placeholder;
    const currVal_103:any = i1.ɵnov(_v,95).disabled;
    const currVal_104:any = i1.ɵnov(_v,95).required;
    const currVal_105:any = (i1.ɵnov(_v,95).ariaDescribedby || (null as any));
    const currVal_106:any = i1.ɵnov(_v,95)._isErrorState();
    _ck(_v,89,1,[currVal_94,currVal_95,currVal_96,currVal_97,currVal_98,currVal_99,
        currVal_100,currVal_101,currVal_102,currVal_103,currVal_104,currVal_105,currVal_106]);
    const currVal_113:any = (null as any);
    const currVal_114:any = i1.ɵnov(_v,105)._mdInputChild._isErrorState();
    const currVal_115:any = i1.ɵnov(_v,105)._mdInputChild.focused;
    const currVal_116:any = i1.ɵnov(_v,105)._shouldForward('untouched');
    const currVal_117:any = i1.ɵnov(_v,105)._shouldForward('touched');
    const currVal_118:any = i1.ɵnov(_v,105)._shouldForward('pristine');
    const currVal_119:any = i1.ɵnov(_v,105)._shouldForward('dirty');
    const currVal_120:any = i1.ɵnov(_v,105)._shouldForward('valid');
    const currVal_121:any = i1.ɵnov(_v,105)._shouldForward('invalid');
    const currVal_122:any = i1.ɵnov(_v,105)._shouldForward('pending');
    _ck(_v,104,0,currVal_113,currVal_114,currVal_115,currVal_116,currVal_117,currVal_118,
        currVal_119,currVal_120,currVal_121,currVal_122);
    const currVal_124:any = (i1.ɵnov(_v,116).required? '': (null as any));
    const currVal_125:any = i1.ɵnov(_v,121).ngClassUntouched;
    const currVal_126:any = i1.ɵnov(_v,121).ngClassTouched;
    const currVal_127:any = i1.ɵnov(_v,121).ngClassPristine;
    const currVal_128:any = i1.ɵnov(_v,121).ngClassDirty;
    const currVal_129:any = i1.ɵnov(_v,121).ngClassValid;
    const currVal_130:any = i1.ɵnov(_v,121).ngClassInvalid;
    const currVal_131:any = i1.ɵnov(_v,121).ngClassPending;
    const currVal_132:any = i1.ɵnov(_v,122).id;
    const currVal_133:any = i1.ɵnov(_v,122).placeholder;
    const currVal_134:any = i1.ɵnov(_v,122).disabled;
    const currVal_135:any = i1.ɵnov(_v,122).required;
    const currVal_136:any = (i1.ɵnov(_v,122).ariaDescribedby || (null as any));
    const currVal_137:any = i1.ɵnov(_v,122)._isErrorState();
    _ck(_v,114,1,[currVal_124,currVal_125,currVal_126,currVal_127,currVal_128,currVal_129,
        currVal_130,currVal_131,currVal_132,currVal_133,currVal_134,currVal_135,currVal_136,
        currVal_137]);
    const currVal_146:any = (null as any);
    const currVal_147:any = i1.ɵnov(_v,131)._mdInputChild._isErrorState();
    const currVal_148:any = i1.ɵnov(_v,131)._mdInputChild.focused;
    const currVal_149:any = i1.ɵnov(_v,131)._shouldForward('untouched');
    const currVal_150:any = i1.ɵnov(_v,131)._shouldForward('touched');
    const currVal_151:any = i1.ɵnov(_v,131)._shouldForward('pristine');
    const currVal_152:any = i1.ɵnov(_v,131)._shouldForward('dirty');
    const currVal_153:any = i1.ɵnov(_v,131)._shouldForward('valid');
    const currVal_154:any = i1.ɵnov(_v,131)._shouldForward('invalid');
    const currVal_155:any = i1.ɵnov(_v,131)._shouldForward('pending');
    _ck(_v,130,0,currVal_146,currVal_147,currVal_148,currVal_149,currVal_150,currVal_151,
        currVal_152,currVal_153,currVal_154,currVal_155);
    const currVal_157:any = (i1.ɵnov(_v,142).required? '': (null as any));
    const currVal_158:any = i1.ɵnov(_v,147).ngClassUntouched;
    const currVal_159:any = i1.ɵnov(_v,147).ngClassTouched;
    const currVal_160:any = i1.ɵnov(_v,147).ngClassPristine;
    const currVal_161:any = i1.ɵnov(_v,147).ngClassDirty;
    const currVal_162:any = i1.ɵnov(_v,147).ngClassValid;
    const currVal_163:any = i1.ɵnov(_v,147).ngClassInvalid;
    const currVal_164:any = i1.ɵnov(_v,147).ngClassPending;
    const currVal_165:any = i1.ɵnov(_v,148).id;
    const currVal_166:any = i1.ɵnov(_v,148).placeholder;
    const currVal_167:any = i1.ɵnov(_v,148).disabled;
    const currVal_168:any = i1.ɵnov(_v,148).required;
    const currVal_169:any = (i1.ɵnov(_v,148).ariaDescribedby || (null as any));
    const currVal_170:any = i1.ɵnov(_v,148)._isErrorState();
    _ck(_v,140,1,[currVal_157,currVal_158,currVal_159,currVal_160,currVal_161,currVal_162,
        currVal_163,currVal_164,currVal_165,currVal_166,currVal_167,currVal_168,currVal_169,
        currVal_170]);
    const currVal_179:any = i1.ɵnov(_v,159).ngClassUntouched;
    const currVal_180:any = i1.ɵnov(_v,159).ngClassTouched;
    const currVal_181:any = i1.ɵnov(_v,159).ngClassPristine;
    const currVal_182:any = i1.ɵnov(_v,159).ngClassDirty;
    const currVal_183:any = i1.ɵnov(_v,159).ngClassValid;
    const currVal_184:any = i1.ɵnov(_v,159).ngClassInvalid;
    const currVal_185:any = i1.ɵnov(_v,159).ngClassPending;
    const currVal_186:any = i1.ɵnov(_v,161).tabIndex;
    const currVal_187:any = i1.ɵnov(_v,161)._ariaLabel;
    const currVal_188:any = i1.ɵnov(_v,161).ariaLabelledby;
    const currVal_189:any = i1.ɵnov(_v,161).required.toString();
    const currVal_190:any = i1.ɵnov(_v,161).disabled.toString();
    const currVal_191:any = (((i1.ɵnov(_v,161)._control == null)? (null as any): i1.ɵnov(_v,
        161)._control.invalid) || 'false');
    const currVal_192:any = i1.ɵnov(_v,161)._optionIds;
    const currVal_193:any = i1.ɵnov(_v,161).disabled;
    _ck(_v,156,1,[currVal_179,currVal_180,currVal_181,currVal_182,currVal_183,currVal_184,
        currVal_185,currVal_186,currVal_187,currVal_188,currVal_189,currVal_190,currVal_191,
        currVal_192,currVal_193]);
    const currVal_199:any = (i1.ɵnov(_v,175).disabled || (null as any));
    _ck(_v,173,0,currVal_199);
    const currVal_202:any = (i1.ɵnov(_v,182).disabled || (null as any));
    _ck(_v,180,0,currVal_202);
  });
}
export function View_ProductEditComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'productedit',
      ([] as any[]),(null as any),(null as any),(null as any),View_ProductEditComponent_0,
      RenderType_ProductEditComponent)),i1.ɵprd(512,(null as any),i11.AuthService,
      i11.AuthService,[i8.Router,i12.ORIGIN_URL]),i1.ɵdid(49152,(null as any),0,i10.ProductEditComponent,
      [i13.SoftwareService,i11.AuthService,i2.MdSnackBar,i8.ActivatedRoute],(null as any),
      (null as any))],(null as any),(null as any));
}
export const ProductEditComponentNgFactory:i1.ComponentFactory<i10.ProductEditComponent> = i1.ɵccf('productedit',
    i10.ProductEditComponent,View_ProductEditComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/containers/productedit/productedit.component.ngfactory.ts